// SSR stub for react-markdown — renders raw text in a div
export default function ReactMarkdown({ children }: { children?: string }) {
  return <div>{children}</div>
}
